import { observer } from 'mobx-react';

import { FilterValue } from '@/catalog/types/filterValue';
import RangeSelectLog from '@/common/components/inputs/RangeSelectLog/RangeSelectLog';

import styles from './MetricGradeNumericRangeSelect.module.css';
import { getMarkByValue, getValuesFromSliderRange, MetricGradeMarks } from './MetricGradeNumericRangeSelect.utils';

/*
 * This range component is used when we have metric without specific range,
 * e.g. [0, 1]
 * */
export interface MetricGradeNumericRangeSelectProps {
  min: number;
  max: number;
  marks: MetricGradeMarks;
  step?: Nullable<number>;
  from?: Nullable<number>;
  to?: Nullable<number>;
  onChange?: Nullable<(value: FilterValue) => void>;
}

function MetricGradeNumericRangeSelect(props: MetricGradeNumericRangeSelectProps) {
  const { step = null, min, max, marks, from = 0, to = 0, onChange = null } = props;

  function onSliderChange(sliderRange: number[]) {
    if (!sliderRange || sliderRange.length !== 2) {
      return;
    }

    onChange?.(getValuesFromSliderRange(marks, sliderRange, min, max));
  }

  return (
    <div className={styles.metricGradeRangeSelect}>
      <RangeSelectLog
        valueMin={getMarkByValue(marks, from, min)}
        valueMax={getMarkByValue(marks, to, min)}
        onChange={onSliderChange}
        marks={marks}
        step={step}
        withTips
      />
    </div>
  );
}

export default observer(MetricGradeNumericRangeSelect);
